import { axiosInstance } from '.'
import { ELIGIBLE_FOR_CUSTOM_TERMS, INVESTOR_OPPORTUNITY_TERMS } from './endpoints'

export const investorOpportunityTermsServices = {
  createInvestorOpportunityTerms: async (payload: {
    investor_id: number
    opportunity_id: number
    [key: string]: any
  }) => {
    try {
      return await axiosInstance.post(INVESTOR_OPPORTUNITY_TERMS, payload)
    } catch (error: any) {
      return error.response
    }
  },

  deleteInvestorOpportunityTerms: async (id: number) => {
    try {
      return await axiosInstance.delete(`${INVESTOR_OPPORTUNITY_TERMS}/${id}`)
    } catch (error: any) {
      return error.response
    }
  },

  getInvestorOpportunityTerms: async (investorId: number, opportunityId: number) => {
    try {
      return await axiosInstance.get(INVESTOR_OPPORTUNITY_TERMS, {
        params: {
          investor_id: investorId,
          opportunity_id: opportunityId,
        },
      })
    } catch (error: any) {
      return error.response
    }
  },

  getOpportunitiesEligibleForCustomTerms: async () => {
    try {
      return await axiosInstance.get(ELIGIBLE_FOR_CUSTOM_TERMS)
    } catch (error: any) {
      return error.response
    }
  },
}
